import React, { useEffect, useRef, useState } from "react";
import { CModal, CModalBody, CModalHeader, CModalTitle } from "@coreui/react";
import { apiClient } from "services/Api";
import DataTableComponent from "components/DataTableComponent";

const apiToMonth = (d) => (d ? d.slice(0, 7) : "");

const Employees = ({ clientId, onClose, setToast }) => {
  const [employees, setEmployees] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  const tableContainerRef = useRef(null);
  const newRowRef = useRef(null);

  useEffect(() => {
    apiClient
      .get(`/projects/management/${clientId}/employees/`)
      .then((response) => {
        const rows = response.data.employees.map((e) => ({
          ...e,
          exit_date: apiToMonth(e.exit_date),
        }));
        setEmployees(rows);
      })
      .catch(() => setError(true))
      .finally(() => setLoading(false));
  }, [clientId]);

  const columns = [
    {
      name: "Nome",
      selector: (row) => row.name,
      sortable: true,
      width: "55%",
      cell: (row) => {
        return (
          <div
            id={`row-${row.id}`}
            ref={row._isNew ? newRowRef : undefined}
            className="text-truncate fw-semibold"
          >
            {row.name}
          </div>
        );
      },
      style: {
        whiteSpace: "nowrap",
        textOverflow: "ellipsis",
        overflow: "hidden",
      },
    },
    {
      name: "Data de Saída",
      selector: (row) => row.exit_date || "-",
      sortable: true,
      center: true,
      width: "25%",
      cell: (row) => {
        return row.exit_date || "-";
      },
    },
    {
      name: "Género",
      selector: (row) => row.gender,
      sortable: true,
      center: true,
      width: "20%",
      cell: (row) => {
        return row.gender || "";
      },
    },
  ];

  return (
    <CModal onClose={onClose} size="lg" backdrop="static" scrollable visible>
      <CModalHeader>
        <CModalTitle>Lista de Funcionários</CModalTitle>
      </CModalHeader>
      <CModalBody ref={tableContainerRef}>
        <DataTableComponent
          columns={columns}
          data={employees}
          loading={loading}
          error={error}
        />
      </CModalBody>
    </CModal>
  );
};

export default Employees;
